import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';

import FlowGraph from './nuiCommon/flow/flowGraph';
import FlowData from './form100FlowData';

export default class Form100GraphSpain extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div style={{height: 780,
                        width: 710}}>
             <CssBaseline />
             <GlobalStyles
               styles={{
                 body: { backgroundColor: "transparent" },
                 ul: { marginTop:4, marginBottom:0, paddingLeft:20 },
                 a: {color: '#0066cc', textDecoration: 'none'},
                 '.react-flow__node': {backgroundColor: "transparent",
                                       borderRadius: '10px'},
                 '.react-flow__edge-text': {backgroundColor: "#f2f2f2"},
                 '.react-flow__edge-textbg': {fill: "#f2f2f2"},
                 'li::marker': {color: "#ED6C02"}
               }}/>
             <FlowGraph data={FlowData}/>
           </div>;
  }
}
